import React, { ReactNode } from 'react';

import {
  CmButton,
  CmDeleteConfirmModal,
  CmFlex,
  CmSeparate,
} from '@/components/uiParts';
import { CmBackLink } from '@/components/uiParts/Link/CmBackLink ';
import {
  BUTTON_AREA_ID,
  ListUrl,
} from '@/pages/menu-managements/components/TopButtonArea';

type Name =
  | 'カテゴリ'
  | 'メニュー配信'
  | '商品'
  | 'メニュー'
  | 'オプショングループ'
  | 'メニュー提供時間';

type Props = {
  urlParamsId: string;
  listUrl: ListUrl;
  name: Name;
  children?: ReactNode;
  isOpenDeleteOpen?: boolean;
  isDisabledSubmitButton: boolean;
  isDisabledDeleteButton?: boolean;
  handleUpdate: (urlParamsId: string) => void;
  handleDuplicate?: (urlParamsId: string) => void;
  handleOpenDeleteModal?: () => void;
  handleDelete?: () => void;
  handleCloseDeleteModal?: () => void;
};

export const MenuManagementEditButtonArea: React.FC<Props> = ({
  urlParamsId,
  name,
  listUrl,
  children,
  isOpenDeleteOpen = false,
  isDisabledSubmitButton,
  isDisabledDeleteButton = false,
  handleUpdate,
  handleDuplicate,
  handleOpenDeleteModal,
  handleDelete,
  handleCloseDeleteModal,
}): JSX.Element => {
  return (
    <CmFlex
      id={BUTTON_AREA_ID}
      justifyContent="space-between"
      padding="20px 20px 20px 0"
      alignItems="center"
    >
      <CmBackLink to={listUrl}>一覧へ戻る</CmBackLink>

      <CmFlex alignItems="center">
        {/*
         // @ts-ignore TS2590 */}
        <CmButton
          onClick={() => handleUpdate(urlParamsId)}
          isDisabled={isDisabledSubmitButton}
        >
          更新
        </CmButton>

        {children}
        {handleDuplicate && (
          <>
            <CmSeparate mx="30px" />

            <CmButton onClick={() => handleDuplicate(urlParamsId)}>
              複製
            </CmButton>
          </>
        )}
        {handleDelete && handleOpenDeleteModal && handleCloseDeleteModal && (
          <>
            <CmSeparate mx="30px" />

            <CmButton
              colorScheme="red"
              onClick={handleOpenDeleteModal}
              isDisabled={isDisabledDeleteButton}
            >
              削除
            </CmButton>

            <CmDeleteConfirmModal
              handleClick={handleDelete}
              {...{ name }}
              isOpen={isOpenDeleteOpen}
              onClose={handleCloseDeleteModal}
              amendment={
                <p> また、他から参照されている場合、紐付けが解除されます。</p>
              }
            />
          </>
        )}
      </CmFlex>
    </CmFlex>
  );
};
